import React from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { useFeedbackStore } from '~/store/feedback.store';
import { useCreateFeedback } from '~/services/feedback/feedback.hooks';

const { TextArea } = Input;

export const NewFeedbackForm: React.FC = () => {
  const [form] = Form.useForm();
  const { isNewFeedbackOpen, closeNewFeedback } = useFeedbackStore();
  const createFeedbackMutation = useCreateFeedback();

  const handleSubmit = async (values: { description: string }) => {
    try {
      await createFeedbackMutation.mutateAsync(values);
      message.success('Feedback submitted successfully!');
      form.resetFields();
      closeNewFeedback();
    } catch (error) {
      message.error('Failed to submit feedback');
    }
  };

  return (
    <Modal
      title="Submit New Feedback"
      open={isNewFeedbackOpen}
      onCancel={() => {
        closeNewFeedback();
        form.resetFields();
      }}
      footer={null}
      width={600}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          label="Bug Description / Feedback"
          name="description"
          rules={[
            { required: true, message: 'Please enter your feedback' },
            { min: 10, message: 'Please provide more details (minimum 10 characters)' }
          ]}
        >
          <TextArea
            rows={6}
            placeholder="Please describe the bug or provide your feedback in detail..."
          />
        </Form.Item>
        
        <Form.Item className="mb-0 text-right">
          <Button onClick={closeNewFeedback} className="mr-2">
            Cancel
          </Button>
          <Button 
            type="primary" 
            htmlType="submit"
            loading={createFeedbackMutation.isPending}
          >
            Submit Feedback
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};